<ion-app>
  <ion-menu #menu contentId="main-content">
    <ion-header>
      <ion-toolbar class="menu">
        <ion-grid class="ion-margin-start">
          <ion-row>
            <ion-col size="2">
              <ion-icon name="person-circle-outline" size="large"></ion-icon>
            </ion-col>
            <ion-col>
              <div class="bold">{{ authService.user?.firstname }}</div>
              <div>{{ authService.user?.email }}</div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-header>
    <!-- Scroll discret : évite la troncature quand l'accordéon facturation est déplié -->
    <ion-content class="menu-content">
      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <a
            class="ion-text-center ion-padding-bottom"
            href="https://extranetprestataire.filrouge.com"
            >Extranet</a
          >
        </ion-row>
        <!-- FR-177 : « Mes missions » retiré — redondant avec l'onglet « En cours »
             de la tab bar, désormais présente sur toutes les pages -->
        <ion-row class="ion-justify-content-center">
          <ion-col size="12">
            <ion-button
              (click)="menu.close()"
              [disabled]="!networkService.isOnline || missionService.syncing"
              [routerLink]="['/actions-enattente']"
              class="menu"
              expand="block">
              <ion-icon name="alert-circle-sharp"></ion-icon>
              Actions en attente
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12">
            <ion-button class="menu" disabled="true" expand="block">
              <ion-icon name="desktop-outline"></ion-icon>
              E-learning
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12">
            <ion-button class="menu" disabled="true" expand="block">
              <ion-icon name="pie-chart"></ion-icon>
              Mes statistiques
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12">
            <!-- Accordéon (FR-165) : déplie les sous-rubriques, ne navigue pas -->
            <ion-button
              (click)="facturationOpen = !facturationOpen"
              class="menu"
              expand="block">
              <ion-icon name="logo-euro"></ion-icon>
              <ion-label>Ma facturation</ion-label>
              <ion-icon
                [class.open]="facturationOpen"
                class="chevron"
                name="chevron-down-outline"></ion-icon>
            </ion-button>

            @if (facturationOpen) {
              <ion-button
                (click)="menu.close()"
                [disabled]="!networkService.isOnline || missionService.syncing"
                [routerLink]="['/ma-facturation']"
                class="menu submenu"
                expand="block">
                <ion-icon name="list-outline"></ion-icon>
                <ion-label>Aide facturation</ion-label>
              </ion-button>
              <ion-button
                (click)="menu.close()"
                [disabled]="!networkService.isOnline || missionService.syncing"
                [routerLink]="['/mes-prefacturations']"
                class="menu submenu"
                expand="block">
                <ion-icon name="receipt-outline"></ion-icon>
                <ion-label>Mes préfacturations</ion-label>
              </ion-button>
            }
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12">
            <ion-button class="menu" disabled="true" expand="block">
              <ion-icon name="chatbubbles"></ion-icon>
              Nous contacter
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12">
            <ion-button class="menu" disabled="true" expand="block">
              <ion-icon name="people"></ion-icon>
              Microsoft Teams
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <!-- Pied fixe : hors zone de scroll, jamais recouvert par la liste de boutons -->
    <ion-footer class="menu-footer">
      <div class="ion-text-center">
        <ion-button (click)="menu.close(); logout()" class="logout">
          Déconnexion
        </ion-button>
      </div>
      <div class="ion-text-center small bold">Version {{ version }}</div>
      <p class="small ion-text-center">
        En cas de problème vous pouvez contacter notre support de 9h30 à 17h30
        au 01 84 20 13 39
      </p>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
